<template>
  <section v-if="slider !== null" class="section">
    <div class="container-lg">
      <div class="section__header">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <h2 class="section__title">
              <img :alt="slider.title" class="section__title-icon" src="/shop/images/top-icon.svg">
              {{ slider.title }}
            </h2>
            <div class="section__text  section__text--indent">
              {{ slider.sub_title }}
            </div>
          </div>
          <div class="col-lg-6 text-right">
            <a :href="slider.link" :title="in18['page_see_all']" class="link  link--gray">
              <b>{{ in18['page_see_all'] }} »</b>
            </a>
          </div>
        </div>
      </div>
      <div class="row justify-content-between">
        <product-item v-for="product in slider.products"
                      :class_name="'col-sm-6 col-md-4 col-lg-3 col-xl-3'"
                      :product="product"
                      display="grid"
        ></product-item>
      </div><!-- /.row -->
    </div>
  </section>
</template>

<script>

import ProductItem from "../product-item/ProductItem.vue";

export default {

  name: "ListSlider",

  components: {
    ProductItem
  },

  props: [
    'type',
    'in18'
  ],

  data() {
    return {
      slider: null
    }
  },

  created() {
    this.load();
  },

  methods: {
    load: function () {
      axios(`/api/slider/${this.type}`).then((response) => {
        this.slider = response.data.slider;
        ga_view_item_list_event(response.data.slider.products);
      });
    }
  }
}
</script>